// extracted by mini-css-extract-plugin
export default {"floatingWhatsapp":"styles_floatingWhatsapp__MOeyX"};